import { Injectable } from "@angular/core";
import { HttpUtilityService } from "src/app/core/services/http.utility.service";
import { InventoryLevelUpdateDto, InventoryLevelUpdateImportFromExcelDto, InventoryLevelUpdateResponseDto } from "../models/change-sar/inventory-level-update.model";
import { Observable, from } from "rxjs";

const urls = {
    inventoryLevel: 'api/RequestLine/inventory-level',
}

@Injectable({
    providedIn: 'root'
})
export class InventoryLevelUpdateService {

    constructor(public httpUtilityService: HttpUtilityService) {
    }

    addNewItem(data: InventoryLevelUpdateDto) : Observable<InventoryLevelUpdateResponseDto> {
        return this.httpUtilityService.postRequest<InventoryLevelUpdateDto, InventoryLevelUpdateResponseDto>(urls.inventoryLevel, data);
    }

    updateItem(data: InventoryLevelUpdateDto) : Observable<InventoryLevelUpdateResponseDto> {
        return this.httpUtilityService.putRequest(urls.inventoryLevel, data);
    }

    getInventoryLevelUpdateData(requestId?: number, requestIssueId?: number | undefined) {
        const httpParams = {
            requestId: requestId,
            requestIssueId: requestIssueId === undefined ?  -1 : requestIssueId
        };

        return this.httpUtilityService.get<InventoryLevelUpdateDto[]>(urls.inventoryLevel, {params : httpParams});
    }

    importItemFromFile(items: InventoryLevelUpdateImportFromExcelDto[]) : Observable<InventoryLevelUpdateResponseDto> {
        return this.httpUtilityService.postRequest<InventoryLevelUpdateImportFromExcelDto[], InventoryLevelUpdateResponseDto>(
            urls.inventoryLevel + '/import', 
            items);
    }
}